import MainFiltersBQ from "../../../../Global/Models/Filters/MainFiltersBQ";

export default class EventGamePredictionsFilters extends MainFiltersBQ {}
